import { ResponseMessage } from './ResponseMessage';
import { HttpErrorResponse } from '@angular/common/http';
import { ResponseMessageType } from './ResponseMessageType';

export class Response {
  messages: ResponseMessage[];
  hasError: boolean;

  constructor(error?: HttpErrorResponse) {
    if (error) {
      this.hasError = true;
      const responseMessage = new ResponseMessage();
      responseMessage.type = ResponseMessageType.Error;
      if (error.status === 401) {
        var path = error.url.split('/');
        var method = path[path.length - 2];
        responseMessage.value = 'Your user account does not have permission to '+method;
      } else {
        responseMessage.value = error.message;
      }
      this.messages = [responseMessage];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/Response.ts